import { Routes } from '@angular/router';
import { AuthSuccessfulComponent } from './common/auth/auth-successful/auth-successful';
import { authGuard } from './common/auth/guards/auth.guard';
import { noAuthGuard } from './common/auth/guards/no-auth.guard';
import { teacherGuard } from './common/auth/guards/teacher.guard';
import { studentGuard } from './common/auth/guards/student.guard';
import { LandingComponent as Wizard2LandingComponent } from './features/app-landing/landing';
import { SignUpComponent } from './common/auth/sign-up/sign-up';
import { DashboardComponent } from './features/teacher/dashboard/dashboard';
import { LoginComponent } from './common/auth/login/login';
import { LessonPlanComponent } from './features/teacher/lesson-plan/lesson-plan';
import { stepContentRoutes } from './features/teacher/lesson-plan/steps/step-content/step-content.routes';
import { SubscriptionTermsComponent } from './common/components/legal/subscription-terms/subscription-terms.component';
import { PrivacyPolicyComponent } from './common/components/legal/privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from './common/components/legal/terms-of-use/terms-of-use.component';
import { EmailPreferencesComponent } from './common/components/email-preferences/email-preferences.component';
import { dashboardRoutes } from './features/teacher/dashboard/dashboard.routes';
import { GradingChatComponent } from './features/teacher/grading-chat/grading-chat.component';
import { AssignmentComponent } from './features/teacher/assignment/assignment';
import { AssignmentDetailComponent } from './features/teacher/assignment-detail/assignment-detail';
import { AssignmentViewComponent } from './features/teacher/assignment-view/assignment-view';
import { AssignmentStudentsComponent } from './features/teacher/assignment-students/assignment-students';
import { SubmissionReviewComponent } from './features/teacher/submission-review/submission-review';
import { RoleRedirectComponent } from './common/auth/role-redirect/role-redirect';
import { StudentDashboardComponent } from './features/student/dashboard/student-dashboard';
import { studentDashboardRoutes } from './features/student/dashboard/student-dashboard.routes';
import { StudentAssignmentComponent } from './features/student/assignment/student-assignment';
import { AssignmentLandingComponent } from './features/assignment-landing/assignment-landing';

export const routes: Routes = [
  // Landing & Auth (shared)
  {
    path: '',
    component: Wizard2LandingComponent,
    canActivate: [noAuthGuard],
  },
  {
    path: 'assignment-landing',
    component: AssignmentLandingComponent,
  },
  {
    path: 'auth-successful',
    component: AuthSuccessfulComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [noAuthGuard],
  },
  {
    path: 'sign-up',
    component: SignUpComponent,
  },

  // Teacher routes
  {
    path: 'teacher/dashboard',
    component: DashboardComponent,
    canActivate: [authGuard, teacherGuard],
    children: dashboardRoutes,
  },
  {
    path: 'lesson-plan',
    component: LessonPlanComponent,
    children: stepContentRoutes,
  },
  {
    path: 'lesson-plan/:id',
    component: LessonPlanComponent,
    children: stepContentRoutes,
  },
  {
    path: 'grading',
    component: GradingChatComponent,
  },
  {
    path: 'grading/:id',
    component: GradingChatComponent,
  },
  {
    path: 'assignment',
    component: AssignmentComponent,
  },
  {
    path: 'assignment/:id',
    children: [
      { path: '', component: AssignmentComponent, pathMatch: 'full' },
      {
        path: 'submission/:submissionId',
        component: SubmissionReviewComponent,
        canActivate: [authGuard, teacherGuard],
      },
      {
        path: '',
        component: AssignmentDetailComponent,
        canActivate: [authGuard, teacherGuard],
        children: [
          { path: 'view', component: AssignmentViewComponent },
          { path: 'students', component: AssignmentStudentsComponent },
        ],
      },
    ],
  },

  // Student routes
  {
    path: 'student/dashboard',
    component: StudentDashboardComponent,
    canActivate: [authGuard, studentGuard],
    children: studentDashboardRoutes,
  },
  {
    path: 'a/:shareCode',
    component: StudentAssignmentComponent,
  },

  // Legal pages (shared)
  {
    path: 'subscription-terms',
    component: SubscriptionTermsComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'terms-of-use',
    component: TermsOfUseComponent,
  },
  {
    path: 'email-preferences',
    component: EmailPreferencesComponent,
  },

  // Catch-all: check role and redirect to appropriate dashboard
  {
    path: '**',
    component: RoleRedirectComponent,
  },
];
